module.exports = __webpack_public_path__ + "img/hot-line.93899163.jpg";